const genAnswer = function (qu, value, refItem) {
  const filterArr = qu.optionList.filter(item => item.value !== 0).map(item => {
    return {
      descId: item.id,
      answer: item.value
    }
  })
  return filterArr.filter(item => item.answer.trim())
}

const setAnswer = function (qu, valueMap, otherAnswerMap) {
  let configValue = []
  Object.keys(valueMap).forEach(key => {
    const value = valueMap[key].join('')
    if (value) {
      configValue.push(value)
    }
    this.optionList.find(item => item.id === key).value = value
  })
  this.value = configValue
}

const answer = {
  genAnswer,
  setAnswer
}

export default answer



// WEBPACK FOOTER //
// ./src/components/editor/MultiFillBlankBox/answer.js